export const CgnIbanControl = new RegExp(
    /^[A-Z]{2}\d{2}(?:\d{4}){5}\d{2}?$/i
  );

  